// extracted by mini-css-extract-plugin
export default {"card":"ResultSection1_card__4if1k","subtitleTop":"ResultSection1_subtitleTop__uZuYU","title":"ResultSection1_title__h4Mcg","subtitleBottom":"ResultSection1_subtitleBottom__J4ATH"};